<template>
  <v-menu offset-y :close-on-content-click="false" @input="onToggle">
    <template #activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on" aria-label="Notifications">
        <v-badge :value="count > 0" :content="count" color="error" overlap>
          <v-icon style="color: var(--app-account-icon, #f7841d)">mdi-bell-outline</v-icon>
        </v-badge>
      </v-btn>
    </template>
    <v-card width="340" max-height="420" class="overflow-y-auto">
      <v-card-actions class="py-1">
        <span class="text-subtitle-2 ml-2">Notifications</span>
        <v-spacer />
        <v-btn text x-small :disabled="!count" @click="readAll">Tout marquer comme lu</v-btn>
      </v-card-actions>
      <v-divider />
      <v-list dense v-if="items.length">
        <v-list-item v-for="n in items" :key="n.id" :class="{ 'font-weight-bold': !n.is_read }" @click="open(n)">
          <v-list-item-content>
            <v-list-item-title>{{ n.title }}</v-list-item-title>
            <v-list-item-subtitle v-if="n.body">{{ n.body }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <div v-else class="pa-4 grey--text text-center">Aucune notification</div>
    </v-card>
  </v-menu>
</template>

<script>
import {
  fetchNotifications, fetchUnreadCount, markNotificationRead, markAllNotificationsRead,
} from '@/services/notificationApi'

const POLL_MS = 60000

export default {
  name: 'NotificationBell',
  data: () => ({ count: 0, items: [], timer: null }),
  created() {
    this.refreshCount()
    this.timer = setInterval(this.refreshCount, POLL_MS)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    async refreshCount() {
      try {
        this.count = (await fetchUnreadCount()).count
      } catch (e) {
        // Badge only: ignore failures.
      }
    },
    async onToggle(opened) {
      if (!opened) return
      try {
        this.items = (await fetchNotifications()).results
      } catch (e) {
        this.items = []
      }
    },
    async open(n) {
      if (!n.is_read) {
        n.is_read = true
        this.count = Math.max(0, this.count - 1)
        markNotificationRead(n.id).catch(() => {})
      }
      if (n.action_url && this.$route.path !== n.action_url) this.$router.push(n.action_url)
    },
    async readAll() {
      await markAllNotificationsRead()
      this.items.forEach((n) => { n.is_read = true })
      this.count = 0
    },
  },
}
</script>
